import React, { useEffect, useState } from 'react';
import styles from './WatchListStyles';
import Table from '@material-ui/core/Table';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { InitialPrice, lastPrice } from './constants';
import OIMODAL from '../../components/Modals/OI Modal';
import RRDOLLAR from '../../components/Modals/RRDollarModal';
import { is_weekend } from '../../components/Modals/UOAModal/getDate';
import WLInitalPriceHeadings from './components/tableOneComponents/initialPrice';
import WLTableOneTBody from './components/tableOneComponents/WLTableOneTBody';

const useStyles = makeStyles({
  root: {
    color: 'darkgrey',
    padding: 0,
    width: 16,
    height: 0,
  },
  MuiSvgIcon: {
    root: {
      height: '0.25rem',
    },
  },
});
const TableOne = ({
  isMobile,
  myFav,
  deleteCheck,
  setmyFav,
  hoverTabelSortLabel,
  sethoverTabelSortLabel,
  orderBy,
  setorderBy,
  order,
  setorder,
  sortData,
  accessLevel,
}) => {
  const classes = useStyles();
  const [OIModal, setOIModal] = useState(false);
  const [rrModal, setrrModal] = useState(false);
  const [modalRowData, setmodalRowData] = useState([]);
  const [newDate, setnewDate] = useState(moment().format('YYYY-MM-DD'));

  const setChekboxes = async (data, index) => {
    let newCh = await JSON.parse(JSON.stringify(myFav));
    if (newCh.length > 0) {
      newCh[index].value = !myFav[index].value;
      await setmyFav(newCh);
      return;
    }
  };

  useEffect(() => {
    let date = is_weekend(newDate);
    setnewDate(date);
  }, []);

  const checkDate = moment().format('YYYY-MM-DD');
  const closeOIModal = () => {
    setOIModal(false);
  };

  const makeModalRowData = (row) => {
    let ObjectTosend = {
      put_call: row.PutCall,
      strike: row.Strike,
      expiration: row.Expiry,
      symbol: row.symbol,
      date: row.date,
    };
    setmodalRowData(ObjectTosend);
    setOIModal(true);
  };

  const makeModalRowDataRRModal = (row) => {
    let ObjectTosend = {
      put_call: row.PutCall,
      strike: row.Strike,
      expiration: row.Expiry,
      symbol: row.symbol,
      date: row.date,
      option: row.option,
    };
    setmodalRowData(ObjectTosend);
    setrrModal(true);
  };

  return (
    <div style={{ width: '100%' }}>
      {OIModal && (
        <OIMODAL
          accessLevel={accessLevel}
          isMobile={isMobile}
          showModal={OIModal}
          ticker={modalRowData.symbol}
          expiration={modalRowData.expiration}
          modalRowData={modalRowData}
          closeOIModal={closeOIModal}
          selectedDate={newDate}
        />
      )}
      {rrModal && (
        <RRDOLLAR
          isMobile={isMobile}
          showModal={rrModal}
          setrrModal={setrrModal}
          ticker={modalRowData.symbol}
          expiration={modalRowData.expiration}
          modalRowData={modalRowData}
          closeOIModal={closeOIModal}
          selectedDate={modalRowData.date}
        />
      )}

      <Table>
        <WLInitalPriceHeadings
          styles={styles}
          isMobile={isMobile}
          deleteCheck={deleteCheck}
          sethoverTabelSortLabel={(data) => sethoverTabelSortLabel(data)}
          order={order}
          orderBy={orderBy}
          sortData={sortData}
          hoverTabelSortLabel={hoverTabelSortLabel}
          InitialPrice={InitialPrice}
          lastPrice={lastPrice}
        />
        <WLTableOneTBody
          order={order}
          orderBy={orderBy}
          styles={styles}
          myFav={myFav}
          checkDate={checkDate}
          deleteCheck={deleteCheck}
          setChekboxes={setChekboxes}
          classes={classes}
          makeModalRowDataRRModal={makeModalRowDataRRModal}
          makeModalRowData={makeModalRowData}
        />
      </Table>
    </div>
  );
};

export default TableOne;



// WEBPACK FOOTER //
// ./src/Pages/WatchList/TableOne.js